import * as React from 'react';
import { MessageWithMetadata } from '../../typedefs/store';
import PresenceMessage from './PresenceMessage';
import MessageMessage from './MessageMessage';

interface Props {
    message: MessageWithMetadata;
    isMostRecentMessage: boolean;
    showAvatars?: boolean;
    send: (message: any, tempId?: string) => void;
    ended: boolean;
    openLinksExternally: boolean;
}

const Message: React.SFC<Props> = props => {
    return props.message.category === 'presence' ? (
        <PresenceMessage message={props.message} />
    ) : (
        <MessageMessage {...props} />
    );
};

export default Message;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/Message.tsx